import { useState } from 'react'
import { useHost, useInstanceId, useView } from '@10000/react'
import { Table } from './table'
import { DateFormatter, TimeDifferenceFormatter, InstanceMenuFormatter } from './table'
import { Box, LoadMoreRows } from '../../widgets'

export const SquizTable = () => {
  const host = useHost()
  const { users, teams } = useView('tenant')
  const [loadedInstances, setLoadedInstances] = useState([])
  const tenantId = useInstanceId('tenant')

  const getSquizzes = async (index, increment) => {
    const rows = await host.getTenantSquizzesByIndex(index, increment, tenantId)
    setLoadedInstances(current => current.concat(rows))
  }

  const columns = [
    { key: 'created', name: 'Created', formatter: DateFormatter },
    { key: 'completed', name: 'Completed', formatter: DateFormatter },
    { key: 'time', name: 'Time Elapsed', formatter: TimeDifferenceFormatter },
    { key: 'leader', name: 'Leader' },
    { key: 'team', name: 'Team' },
    { key: 'presenterPlayed', name: 'Presenter Played' },
    { key: 'settings', name: 'Settings', formatter: InstanceMenuFormatter },
  ]

  const rows = loadedInstances.map(({ id, created, exited, leaderId, teamId, presenterParticipates, region }) => ({
    created,
    completed: exited || -1,
    time: exited ? exited - created : Date.now() - created,
    leader: users.find(x => x.id === leaderId)?.name,
    team: teams.find(x => x.id === teamId)?.name,
    presenterPlayed: presenterParticipates ? 'Yes' : 'No',
    settings: true,
    region,
    id,
    exited
  }))

  return (
    <Box column fullWidth>
      <Table
        title="Squizzes"
        rows={rows}
        columns={columns}
        defaultSortColumn="created"
      />
      <LoadMoreRows
        rows={loadedInstances}
        onLoadRows={getSquizzes}
        loadIncrement={10}
      />
    </Box>
  )
}
